var parent = require('../../actual/object/get-own-property-symbols');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/full/object/get-own-property-symbols.js
// module id = 3494
// module chunks = 25